module.exports = __webpack_public_path__ + "static/media/My_Thai.546ebc07.png";